import { ApiClient } from "client/base";
export class CloudMetadataClient extends ApiClient {
    setReportConversation(id, request) {
        return this.base.post(`v1/metadata/conversations/${id}`, request);
    }
    getReportConversation(id) {
        return this.base.get(`v1/metadata/conversations/${id}`);
    }
    setReportMetadata(id, request) {
        return this.base.post(`v1/metadata/reports/${id}`, request);
    }
    getReportMetadata(id) {
        return this.base.get(`v1/metadata/reports/${id}`);
    }
}
